// extracted by mini-css-extract-plugin
export default {"question":"Question_question__vQem9"};